import React, { useEffect, useRef, useState, forwardRef } from 'react';
import { useBiblStore } from '../hooks/useBiblStore';
import { Button, Form } from 'react-bootstrap';
import { useCatSearchStore } from '../hooks/useCatSearchStore';
import { Link, Redirect, useHistory, useRouteMatch } from 'react-router-dom';
import axios from 'axios';
import jsonpAdapter from '../common/axios-jsonp';
import { useCookies } from 'react-cookie';
import { IoArrowBack } from 'react-icons/all';
import { getLangCodeForString } from '../common/utils';
import { convertWylie, isTib } from '../../views/common/utils';
import { EwtsConverter } from '../../views/TranslationTool/src/EwtsConverter.mjs';

export function NavBasicSearch() {
    const search = useCatSearchStore();
    const [disabled, setDisabled] = useState(false);
    // When searchstr state is changed, the search is initiated
    const [searchStr, setSearchStr] = useState(null);
    const [doSearch, setDoSearch] = useState(false);
    // const [doRedirect, setRedirect] = useState(false); // state to trigger redirect to search page
    // const [convertWylie, setConvertWylie] = useState(false);
    const defaultLang = search?.query?.length > 0 ? search.queryLang : 'en';
    const [searchBoxLang, setSearchBoxLang] = useState(defaultLang);

    let onSearchPage = useRouteMatch('/catalog/search');
    const history = useHistory();
    const searchBox = useRef(); // Reference to html text input where search string is entered

    const ewtsConv = new EwtsConverter();
    //  console.log('on search page', onSearchPage);

    // const wyliecbRef = useRef();
    const cookie_names = [
        'thlcat_convwyl',
        'thlcat_searchactive',
        'thlcat_searchquery',
    ];
    const [cookies, setCookie, removeCookie] = useCookies(cookie_names);

    const submitSearch = (e) => {
        if (e) {
            e.preventDefault();
            //console.log("submit e", e);
        }
        if (searchBox?.current?.value) {
            setSearchStr(searchBox.current.value);
        }
        setDoSearch(true);
    };
    /* Separated out into a standalone component below: SearchWylieInput
    const checkKeyDown = (e) => {
        const sbval = searchBox?.current?.value;
        setSearchBoxLang(getLangCodeForString(sbval));
        if (e.key === 'Enter') {
            e.preventDefault();
            checkWylie();
            submitSearch(e);
        }
    };*/

    const clearForm = () => {
        setSearchStr(null);
        if (searchBox?.current) {
            searchBox.current.value = '';
            searchBox.current.classList.remove('bo');
        }
    };
    /*
    const checkWylie = () => {
        const inval = searchBox?.current?.value.replace(/\s+/g, ' ');
        if (search?.convWy) {
            if (inval?.length > 0) {
                if (!isTib(inval) && search.convWy) {
                    let bo = ewtsConv.to_unicode(inval);
                    const lastbo = bo.slice(-1);
                    const lastin = inval.slice(-1);
                    // console.log(`bo ${bo} lastbo ${lastbo} lastin ${lastin} inval ${inval}`)
                    if (lastbo === '་' && lastin !== ' ') {
                        bo = bo.slice(0, -1);
                    }
                    searchBox.current.value = bo;
                    searchBox.current.classList.add('bo');
                    setSearchStr(bo);
                } else if (isTib(inval)) {
                    searchBox.current.classList.add('bo');
                    setSearchStr(inval);
                }
            }
        } else {
            searchBox.current.classList.remove('bo');
            // console.log(`inval is [${inval}]`);
            setSearchStr(inval);
        }
    };*/

    useEffect(() => {
        if (!search?.isAdvanced) {
            if (search?.query && search.query !== '*:*') {
                searchBox.current.value = search.query;
                if (isTib(search.query)) {
                    searchBox.current.classList.add('bo');
                }
            } else {
                searchBox.current.value = '';
                searchBox.current.classList.remove('bo');
            }
        }
    }, [search]);

    useEffect(() => {
        if (doSearch === true) {
            //console.log(`doing search for ${searchStr}`);
            search.setQuery(searchStr);
            search.setActive(true);
            history.push('/catalog/search');
            setDoSearch(false);
        }
    }, [doSearch]);

    useEffect(() => {
        if (search?.isAdvanced) {
            clearForm();
        }
    }, [search?.isAdvanced]);

    const onSearchClass = onSearchPage && search?.showing ? ' search-page' : '';
    return (
        <Form className="nav-search-form d-flex p-2" action="">
            <div className={`search-and-back${onSearchClass}`}>
                {/*}
                <Form.Control
                    type="search"
                    placeholder="Search & Explore!"
                    className={`me-2 cat-search ${searchBoxLang}`}
                    aria-label="Search"
                    ref={searchBox}
                    onKeyDown={checkKeyDown}
                    disabled={disabled}
                    onBlur={checkWylie}
                />

                SearchWylieInput({ lang, submit, setSearch, ref })
                */}
                <SearchWylieInput
                    lang={searchBoxLang}
                    submit={submitSearch}
                    setSearch={setSearchStr}
                    ref={searchBox}
                />

                {/*  onBlur={setInputVal} */}

                <Button
                    variant="success"
                    onClick={submitSearch}
                    className="submit-btn"
                    disabled={disabled}
                >
                    <strong>Search</strong>
                </Button>
            </div>
        </Form>
    );
}

export const SearchWylieInput = forwardRef((props, ref) => {
    const { lang, submit, setSearch } = props;
    const search = useCatSearchStore();
    const [disabled, setDisabled] = useState(false);
    const [searchBoxLang, setSearchBoxLang] = useState(lang);

    const ewtsConv = new EwtsConverter();

    const checkKeyDown = (e) => {
        const sbval = ref?.current?.value;
        setSearchBoxLang(getLangCodeForString(sbval));
        if (e.key === 'Enter') {
            e.preventDefault();
            checkWylie();
            submit(e);
        }
    };

    const checkWylie = () => {
        const inval = ref?.current?.value.trim();
        if (search?.convWy) {
            if (inval?.length > 0) {
                if (!isTib(inval) && search.convWy) {
                    const bo = ewtsConv.to_unicode(inval + ' ');
                    ref.current.value = bo;
                    ref.current.classList.add('bo');
                    setSearch(bo);
                } else if (isTib(inval)) {
                    ref.current.classList.add('bo');
                    setSearch(inval);
                }
            }
        } else {
            ref.current.classList.remove('bo');
            setSearch(inval);
        }
    };

    return (
        <Form.Control
            type="search"
            placeholder="Search & Explore!"
            className={`me-2 cat-search ${searchBoxLang}`}
            aria-label="Search"
            ref={ref}
            onKeyDown={checkKeyDown}
            disabled={disabled}
            onBlur={checkWylie}
        />
    );
});
